import React, { useEffect } from 'react'
import { ApiGetCall } from '../../../JS/Connector';
import { formatDateToMMDDYYYY, HideLoder, sanitizeCSVField, ShowLoder } from '../../../JS/Common';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { log } from '../../../JS/Logger';

export default function ExportCustomPriceParts({ FilterData }) {
    const [loading, setLoading] = useState(false);
    const [customDataPartCsv, setCustomPartDataCsv] = useState([]);
    const [divVisibleForExport, setDivVisibleForExport] = useState({
        forUsers: false,
        forUsersNoRecord: false
    });
    const [filterValues, setFilterValues] = useState({
        accountName: null,
        accountNameArray: [],
        relationManger: null,
        relationMangerArray: [],
        location: null,
        locationArray: []
    })

    const headers = [
        { label: "Account Name", key: "accountName" },
        { label: "Part Name", key: "partName" },
        { label: "Part Price", key: "customPrice" },
        { label: "Location", key: "locationName" },
    ];

    useEffect(() => {
        getSchoolCustomPartsFilterData();
    }, [])

    async function ExportInventory() {
        setLoading(true);
        await ApiGetCall(`/schools/custom-parts/export?schoolFlag=${filterValues.accountName}&managerFlag=${filterValues.relationManger}&locationFlag=${filterValues.location}&startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    if (responseRs?.data?.length != 0) {
                        const extractData = responseRs?.data?.map(item => ({
                            accountName: item?.school?.name,
                            partName: item?.part?.title,
                            customPrice: item?.custom_price,
                            locationName: item?.school?.location?.name,
                        }));
                        setCustomPartDataCsv(extractData);
                        setDivVisibleForExport({ ...divVisibleForExport, forUsers: true, forUsersNoRecord: false });
                    } else {
                        setCustomPartDataCsv([]);
                        setDivVisibleForExport({ ...divVisibleForExport, forUsersNoRecord: true, forUsers: false });
                    }
                }
                setLoading(false);
            }
        });
    }

    async function getSchoolCustomPartsFilterData() {
        await ApiGetCall(`/schools/custom-parts/filter-data`).then((result) => {
            if (result == undefined || result == "") {
                log.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setFilterValues({
                        ...filterValues,
                        accountNameArray: responseRs?.schools,
                        relationMangerArray: responseRs?.relationship_managers,
                        locationArray: responseRs?.locations,
                    })
                }
            }
        });
    }

    function RemoveUserCsv() {
        setCustomPartDataCsv([]);
        setDivVisibleForExport({ ...divVisibleForExport, forUsers: false, forUsersNoRecord: false });
    }

    const FIELDS_TO_SANITIZE = ['accountName', 'partName'];

    function downloadCSv(data) {
        const headerRow = headers.map(h => h.label).join(',');

        const rows = data.map(row =>
            headers.map(h => sanitizeCSVField(h.key, row[h.key], FIELDS_TO_SANITIZE)).join(',')
        );

        const csvContent = [headerRow, ...rows].join('\r\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'CustomPriceforParts.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

    return (
        <div>
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='row d-flex align-items-center p-1'>
                <span className='GridTitle'>Export Custom Pricing for Parts </span>
            </div>
            <div className='col-12'>
                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
            </div>
            <div className="p-2">
                <p className="text-justify" style={{ fontSize: "13px" }}>
                    Would you like to export your Custom Pricing for Parts data? To do so, simply click on the 'Export Custom Pricing for Parts' button.
                </p>
                <div className='row'>
                    <div className='col-md-6'>
                        <select onChange={(e) => setFilterValues({ ...filterValues, accountName: e.target.value == 0 ? null : e.target.value })}>
                            <option value="0">Filter by Account Name</option>
                            {filterValues.accountNameArray?.map((item, index) => {
                                return <option key={index} value={item.id}>{item.name}</option>
                            })}
                        </select>
                    </div>
                    <div className='col-md-6'>
                        <select onChange={(e) => setFilterValues({ ...filterValues, relationManger: e.target.value == 0 ? null : e.target.value })}>
                            <option value="0">Filter by Relationship Manager</option>
                            {filterValues.relationMangerArray?.map((item, index) => {
                                return <option key={index} value={item.id}>{item.first_name} {item.last_name}</option>
                            })}
                        </select>
                    </div>
                    <div className='col-md-6 pt-3'>
                        <select onChange={(e) => setFilterValues({ ...filterValues, location: e.target.value == 0 ? null : e.target.value })}>
                            <option value="0">Filter by Location</option>
                            {filterValues.locationArray?.map((item, index) => {
                                return <option key={index} value={item.id}>{item.name}</option>
                            })}
                        </select>
                    </div>
                </div>
                <div className="row pt-3 pb-2 px-3">
                    <div className="col-12 px-0 py-2">
                        <label className='BorderBtnForimportExport' onClick={ExportInventory}>Export Custom Pricing for Parts
                            <img src='/images/ExportInventory.svg' className='img-fluid ps-2' />
                        </label>
                    </div>

                </div>
                {divVisibleForExport.forUsers &&
                    <div className="row pt-2" >
                        <div>Your Custom Pricing for Parts CSV file is now ready for download. Please click the button below to initiate the file download.</div>
                        <div className="col-12 mt-1 text-center">
                            <label style={{ fontSize: "12px", color: "#04ADFD" }} id="ExportedStudentFileName">
                                CustomPriceForParts.csv
                            </label>
                            <button className='SaveBtn ms-4' onClick={() => downloadCSv(customDataPartCsv)}>Download</button>
                            <FontAwesomeIcon icon={faCircleXmark} className="cursor-pointer ps-3" onClick={RemoveUserCsv} />
                        </div>
                    </div>
                }
                {divVisibleForExport.forUsersNoRecord &&
                    <div className="row pt-2">
                        <div className="custom-text-danger">No Record Found!</div>
                    </div>
                }
            </div>
        </div>
    )
}
